export const PolicySectionBorder = () => (
  <div className="w-full border-b-2 my-11 border-deepPurple"></div>
)
